/*
 * Copyright 2022, Corning Optical Communications
 * All Rights Reserved.
 */
import React from "react";
import { Divider, Grid, IconButton, Typography } from "@mui/material";
//import { Close } from "@mui/icons-material";
import { setBasicPopoverAnchorEl } from "../../store/helpers/helperReducers";
import { Link } from "react-router-dom";
import ListSecondary from "../Shared/List/ListSecondary";
import { listPopoverProps, headerStyle, footerDividerStyle, footerStyle } from "../helpers";
import { useDispatch } from "react-redux";
import { useConfigAlertData } from "./hooks";

const ConfigAlerts: React.FC = () => {
  const dispatch = useDispatch();
  const { permissions, data, acklnowledgeHandler } = useConfigAlertData();

  return (
    <>
      <Grid item sm={12} xs={12} container direction="row" sx={headerStyle}>
        <Grid item sm={11} xs={11} alignItems="center">
          <Typography component="h5" variant="subtitle1">
            Operations
          </Typography>
        </Grid>
        <Grid item sm={1} xs={1} justifyContent="flex-end" alignItems="center" display="flex">
          <IconButton color="primary" onClick={() => dispatch(setBasicPopoverAnchorEl(null))}>
            {/* <Close fontSize="small" /> */}
          </IconButton>
        </Grid>
      </Grid>
      <Divider sx={{ width: "100%" }} />
      <Grid item md={12} sx={listPopoverProps}>
        {!!data && data?.length > 0 ? (
          <ListSecondary listData={data} onRowClickHandler={acklnowledgeHandler} />
        ) : (
          <Grid item sm={12} xs={12} sx={{ justifyContent: "center", alignItems: "center", display: "flex" }}>
            <Typography component="h6">No data found!</Typography>
          </Grid>
        )}
      </Grid>

      {!!data && data?.length > 0 && (
        <>
          <Divider sx={footerDividerStyle} />
          <Grid item sm={12} xs={12} sx={footerStyle}>
            {/* <Link to="#" className="alert-link">
          See all Alerts
        </Link> */}
            {permissions?.hasOpCodeGroup("manage_topology") && (
              <Link to="#" className="alert-link" onClick={(e) => acklnowledgeHandler(e, "CLEARALL")}>
                Clear All
              </Link>
            )}
          </Grid>
        </>
      )}
      <Grid />
    </>
  );
};
export default ConfigAlerts;
